import { render, staticRenderFns } from "./create-app.vue?vue&type=template&id=4e8c1255&scoped=true&"
import script from "./create-app.js?vue&type=script&lang=js&"
export * from "./create-app.js?vue&type=script&lang=js&"
import style0 from "./create-app.scss?vue&type=style&index=0&id=4e8c1255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c1255",
  null
  
)

component.options.__file = "create-app.vue"
export default component.exports